import actionTypes from '../actionTypes/actionTypes';

export const initialState = {
  id: '',
  title: '',
  username: '',
  name: '',
  lastName: '',
  email: '',
  password: '',
  gender: -1,
  admin: false,
  role: 0
}

// 0 - User (Test environment)
// 1 - Writer (Write Text / Save / Ready For Proof - No Publish)
// 2 - Proofreader (Proof / Edit Text / Ready For Publish - No Publish)
// 3 - Publisher (Publish)
// 4 - Manager (Change Settings and Roles)
// 5 - Admin (All)

function userReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_LOGIN:
      return Object.assign({}, state, {
      	id: action.data && action.data.user && action.data.user.id ? action.data.user.id : '',
      	title: action.data && action.data.user && action.data.user.title ? action.data.user.title : '',
        username: action.data && action.data.user && action.data.user.username ? action.data.user.username : '',
        name: action.data && action.data.user && action.data.user.name ? action.data.user.name : '',
        lastName: action.data && action.data.user && action.data.user.lastName ? action.data.user.lastName : '',
        gender: action.data && action.data.user && action.data.user.gender ? action.data.user.gender : '',
        email: action.data && action.data.user && action.data.user.email ? action.data.user.email : '',
        admin: action.data && action.data.user && action.data.user.admin ? action.data.user.admin : false,
        role: action.data && action.data.user && action.data.user.role ? action.data.user.role : 0
      })
    case actionTypes.REQUEST_REGISTER:
      return Object.assign({}, state, {
        id: action.data && action.data.user && action.data.user.id ? action.data.user.id : '',
        username: action.data && action.data.user && action.data.user.username ? action.data.user.username : '',
        admin: action.data && action.data.user && action.data.user.admin ? action.data.user.admin : false,
        role: action.data && action.data.user && action.data.user.role ? action.data.user.role : 0
      })
      break
    default:
      return state
  }
}

export default userReducer;